import { render, staticRenderFns } from "./ProductStockExcel.vue?vue&type=template&id=446fce7e"
import script from "./ProductStockExcel.vue?vue&type=script&lang=js"
export * from "./ProductStockExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports